import { number } from 'prop-types';

export const iconDimensionsPropTypes = {
  width: number,
  height: number,
};

export const getDefaultIconDimensionsProps = (width, height) => ({ width, height });

export const getSvgDimensionsProps = ({ width, height }) => ({
  width,
  height,
});

export const getViewBoxProperty = ({ width, height }) => ({
  viewBox: `0 0 ${width} ${height}`,
});



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/helpers.js